import React from 'react';
import { useTranslation } from 'react-i18next';
import Button from '../../../components/envago/Button/Button';

const CandidatePicker = ({ candidates, onChoose }: { candidates: string[]; onChoose: (meterNumber: string) => void }) => {
    const { t } = useTranslation();
    return (
        <div className={'absolute bottom-0 left-0 right-0 bg-white rounded-t-xl p-4'}>
            <h3>{t('aiReading.candidates.title')}</h3>
            <div className={'flex flex-col gap-2 mt-2'}>
                {candidates.map((candidate) => (
                    <Button key={candidate} secondary={true} block={true} onClick={() => onChoose(candidate)}>
                        {candidate}
                    </Button>
                ))}
            </div>
        </div>
    );
};

export default CandidatePicker;
